<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item class="query-form-item">
                <el-input v-model="query.name" placeholder="请输入礼品名称" prefix-icon="el-icon-search"
                    @keyup.enter.native="getList" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
                <el-button type="primary" @click="viewAdd">添加</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
            border>
            <el-table-column type="selection" fixed />
            <!-- <el-table-column label="ID" prop="id" width="80" align="center" /> -->
            <el-table-column label="缩略图" prop="imgUrl" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                    <el-popover placement="right" trigger="hover">
                        <img :src="scope.row.imgUrl" style="width:400px;border-radius:3px;">
                        <img slot="reference" :src="scope.row.imgUrl"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;">
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="礼品编码" prop="giftCode" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="礼品名称" prop="name" width="400" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="积分" prop="integralNum" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="上/下架" prop="showStatus" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                    <el-switch active-color="#13ce66" v-model="scope.row.showStatus!=1?false:true"
                        @change="backgroundChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="240" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" plain @click.native="viewDetails(scope.row.id)">查看
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="viewEdit(scope.row.id)">编辑
                    </el-button>
                    <el-button type="danger" size="mini" @click.native="handleDel(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
        </div>
        <el-pagination class="pagination-container" background :current-page="query.currentPage"
            :page-size="query.pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>

        <!-- 编辑 -->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="800px"
            top="5vh" v-dialogDrag>
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="管理员账号:" prop="name">
                    <el-input placeholder="填写账号" v-model="formData.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="登录密码:" prop="password">
                    <el-input type="password" placeholder="填写密码" v-model="formData.password" clearable></el-input>
                </el-form-item>
                <el-form-item label="管理员角色:" prop="roleId">
                    <el-select v-model="formData.roleId" placeholder="请选择角色" clearable>
                        <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名:" prop="compellation">
                    <el-input placeholder="填写姓名" v-model="formData.compellation" clearable></el-input>
                </el-form-item>
                <div v-if="this.formData.roleId == 1">
                    <el-form-item label="电话:" prop="tel">
                        <el-input placeholder="填写电话" v-model="formData.tel" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="email:" prop="email">
                        <el-input placeholder="填写email" v-model="formData.email" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="Skype:" prop="avatar">
                        <el-input placeholder="填写Skype" v-model="formData.avatar" clearable></el-input>
                    </el-form-item>
                </div>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        giftList,
        updateShowStatusApi,
        authAdminRoleList,
        authAdminSave,
        delIntegralGifApi,
        deleteNewApi
    } from "@/api/integral/integral";
    const formJson = {
        id: "",
        password: "",
        name: "",
        compellation: "",
        roleId: "",
        tel: "",
        email: "",
        avatar: "",
        status: 1,
        roles: []
    };
    export default {
        data() {
            let validatePass = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请输入密码"));
                } else {
                    callback();
                }
            };
            return {
                query: {
                    name: "",
                    currentPage: 1,
                    pageSize: 10,
                },
                roles: [],
                list: [],
                totalNumber: 0,
                loading: true,
                index: null,
                formName: null,
                formMap: {
                    add: "添加",
                    edit: "编辑"
                },
                cancelToggle: false,
                formLoading: false,
                formVisible: false,
                formInput: false,
                formData: formJson,
                formAdd: formJson,
                formRules: {},
                addRules: {
                    name: [{
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }],
                    password: [{
                            required: true,
                            message: "请输入密码",
                            trigger: "blur"
                        },
                        {
                            validator: validatePass,
                            trigger: "blur"
                        }
                    ],
                    roleId: [{
                        required: true,
                        message: "请选择角色",
                        trigger: "blur"
                    }],
                    compellation: [{
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur"
                    }],
                    tel: {
                        required: true,
                        message: "请输入电话",
                        trigger: "blur"
                    },
                    email: {
                        required: true,
                        message: "请输入邮箱",
                        trigger: "blur"
                    },
                    avatar: {
                        required: true,
                        message: "请输入Skype",
                        trigger: "blur"
                    }
                },
                editRules: {
                    name: [{
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }],
                    password: [{
                            required: true,
                            message: "请输入密码",
                            trigger: "blur"
                        },
                        {
                            validator: validatePass,
                            trigger: "blur"
                        }
                    ],
                    roleId: [{
                        required: true,
                        message: "请选择角色",
                        trigger: "blur"
                    }],
                    compellation: [{
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur"
                    }],
                    tel: {
                        required: true,
                        message: "请输入电话",
                        trigger: "blur"
                    },
                    email: {
                        required: true,
                        message: "请输入邮箱",
                        trigger: "blur"
                    },
                    avatar: {
                        required: true,
                        message: "请输入Skype",
                        trigger: "blur"
                    }
                },
                multipleSelection: [] //多选集合
            };
        },
        methods: {
            // 上下架
            backgroundChange(row) {
                let data = {
                    id: row.id,
                    showStatus: row.showStatus == 1 ? 2 : 1
                };
                console.log(data)
                updateShowStatusApi(data)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success('操作成功！');
                        this.getList();
                    })
                    .catch(() => {});
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
                // var ids = this.multipleSelection.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                // if (ids == "") {
                //     this.$message({
                //         message: "请先选择",
                //         type: "warning"
                //     });
                //     return;
                // }

                // this.$confirm("确认要删除吗?", "提示", {
                //         type: "warning"
                //     })
                //     .then(() => {
                //         this.multipleSelection.forEach(tiem => {
                //           console.log("idddddddd",tiem.id)
                //             let para = {
                //                 ids: tiem.id
                //             };
                //             delIntegralGifApi(para)
                //                 .then(response => {})
                //         })
                //         this.$message.success("删除成功");
                //         this.getList();
                //     })
            },
            onRest() {
                this.query = {
                    name: "",
                    currentPage: 1,
                    pageSize: 10,
                };
                this.getList();
            },
            onSubmit() {
                this.query.currentPage = 1;
                // this.$router.push({
                //     path: ""
                //     //query: this.query
                // });
                this.$router.push({
                    path: "/integral/details",
                });
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },
            regetlist(){
              this.query.currentPage=this.query.currentPage-1
              this.getList();
            },
            getList() {
                this.loading = true;
                giftList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        if (this.query.currentPage > 1 && response.data.list.length < 1) {
                            this.regetlist();
                        } else {
                            this.list = response.data.list || [];

                            this.totalNumber = response.data.totalNumber || 0;
                            setTimeout(() => {
                                this.loading = false;
                            }, 0.3 * 1000);
                        }

                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                        this.roles = [];
                    });
            },
            getRoleList() {
                authAdminRoleList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.roles = response.data.list || [];
                    })
                    .catch(() => {});
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.formData.name = "";
                this.formData.password = "";
                return true;
            },
            viewDetails(id) {
                //带参数跳转
                this.$router.push({
                    path: "/integral/details",
                    query: {
                        id: id,
                        isEdit: 0
                    }
                });
            },
            viewAdd() {
                this.$router.push({
                    path: "/integral/details",
                    query: {
                        isEdit: 1
                    }
                });
            },
            viewEdit(id) {
                //带参数跳转
                this.$router.push({
                    path: "/integral/details",
                    query: {
                        id: id,
                        isEdit: 1
                    }
                });
            },
            // 显示表单
            handleForm(index, row) {
                this.formVisible = true;
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                // this.formData.password = "";
                this.formName = "add";
                this.formData.checkPassword = "";
                this.formRules = this.addRules;
                //编辑
                if (index !== null) {
                    this.index = index;
                    this.formName = "edit";
                    this.formRules = this.editRules;
                }
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },
            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;
                        let data = Object.assign({}, this.formData);
                        authAdminSave(data, this.formName).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            // 刷新表单
                            this.$refs["dataForm"].resetFields();
                            this.formVisible = false;
                            this.getList();
                        });
                    }
                });
            },
            // 删除
            handleDel(ids) {
                if (ids) {
                    this.$confirm("确认要删除吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.loading = true;
                            // var params = new URLSearchParams();
                            // params.append("ids", ids.toString());
                            deleteNewApi({
                                    ids: ids.toString()
                                })
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("删除成功");
                                    this.getList();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
                // if (ids) {
                //     this.$confirm("确认要删除吗?", "提示", {
                //             type: "warning"
                //         })
                //         .then(() => {
                //             this.loading = true;
                //             let para = {
                //                 ids: ids
                //             };
                //             delIntegralGifApi(para)
                //                 .then(response => {
                //                     this.loading = false;
                //                     if (response.code) {
                //                         this.$message.error(response.message);
                //                         return false;
                //                     }
                //                     this.$message.success("删除成功");
                //                     this.getList();
                //                 })
                //                 .catch(() => {
                //                     this.loading = false;
                //                 });
                //         })
                //         .catch(() => {});
                // }
            }
        },
        filters: {
            statusFilterType(status) {
                const statusMap = {
                    0: "gray",
                    1: "success",
                    2: "danger"
                };
                return statusMap[status];
            },
            statusFilterName(status) {
                const statusMap = {
                    0: "禁用",
                    1: "正常",
                    2: "未验证"
                };
                return statusMap[status];
            }
        },
        mounted() {},
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.getList();
            // 加载角色列表
            this.getRoleList();
        }
    };

</script>

<style scoped>
    .el-table .cell,
    .el-table--border .el-table__cell:first-child .cell {
        padding-left: 16px;
    }

</style>
